import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { setShowingDetailId } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector } from "./selectors";
import { type MemberVouchers } from "./types";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      items: localState.vouchers,

      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onItemClick: (item: MemberVouchers.Voucher) =>
    dispatch(setShowingDetailId({ ...getEntityRef(props), itemId: item.voucherCodeId }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
